export default __webpack_public_path__ + "static/gsa-3047fba77a27eb2f9f1bff69230e254b.png";